import React from 'react';

import { Table, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';

import {
  EmployeeChangeLogUpdatedFields,
  PersonChangeLogUpdatedFields,
} from '../../typescript-types/employee-change-log';

import { humanizeCamelCaseString } from '../../util/formatters';
import { getValueChanges } from '../util/get-value-changes';

type ValueChange = {
  field: string;
  newValue: any;
  oldValue: any;
};

type InputProps = {
  className?: string;
  changeHistoryId: number;
  employeeChanges?: EmployeeChangeLogUpdatedFields | null;
  orgsInAccount: Array<Org>;
  personChanges?: PersonChangeLogUpdatedFields | null;
};

const ValueCell = ({
  label,
  index,
  valueChangesToDisplay,
}: {
  label: string;
  index: number;
  valueChangesToDisplay: ValueChange[];
}) => (
  <TableCell
    style={{
      width: '33%',
      ...(index === valueChangesToDisplay.length - 1 ? { borderBottom: 'none' } : {}),
    }}
  >
    <div className="typo-subtitle u-overflowWrap-breakWord">{label}</div>
  </TableCell>
);

export const EmployeeHistoryEmployeePersonDetail = (props: InputProps) => {
  const { className, changeHistoryId, employeeChanges, orgsInAccount, personChanges } = props;

  const valueChangesToDisplay = getValueChanges(employeeChanges ?? {}, orgsInAccount).concat(
    getValueChanges(personChanges ?? {}, orgsInAccount),
  );

  const hasIntegrationIdChange = employeeChanges?.integrationId;

  if (!valueChangesToDisplay.length && !hasIntegrationIdChange) {
    return null;
  }

  return (
    <Table size="small" className={className} style={{ tableLayout: 'fixed' }}>
      <TableHead>
        <TableRow>
          <TableCell style={{ width: '33%' }}>
            <div className="typo-subtitle typo-bold">Field</div>
          </TableCell>
          <TableCell style={{ width: '33%' }}>
            <div className="typo-subtitle typo-bold">New Value</div>
          </TableCell>
          <TableCell style={{ width: '33%' }}>
            <div className="typo-subtitle typo-bold">Old Value</div>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {hasIntegrationIdChange && (
          <TableRow>
            <TableCell>
              <div className="typo-subtitle">Linked Team Engine employee to HRIS record</div>
            </TableCell>
          </TableRow>
        )}
        {valueChangesToDisplay.map((change, index) => (
          <TableRow key={`${changeHistoryId}-${change.field}`}>
            <ValueCell
              label={humanizeCamelCaseString(change.field)}
              index={index}
              valueChangesToDisplay={valueChangesToDisplay}
            />
            <ValueCell
              label={change.newValue}
              index={index}
              valueChangesToDisplay={valueChangesToDisplay}
            />
            <ValueCell
              label={change.oldValue}
              index={index}
              valueChangesToDisplay={valueChangesToDisplay}
            />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
